module.exports = __webpack_public_path__ + "static/img/Image_island.79eba0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Image_island.png
// module id = 8ySe
// module chunks = 0